module.exports = __webpack_public_path__ + "body3-bg.png?0ed8f42a08ee50ce8cd7ffdd570c3c8f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body3-bg.png
// module id = 169
// module chunks = 0